// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const HoldMusicService = {
    /**
     * List hold music for each location under a tenant
     * Each location along with the Hold Music will be displayed
     */
    List(fn, req) {
        return fn(`/phone/hold-music/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Display a list of system media - default and original
     */
    ListSystem(fn, req) {
        return fn(`/phone/hold-music/v1/system?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/hold-music/v1/${req["mediaItemId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
